import { render, staticRenderFns } from "./PAKurzpruefung.vue?vue&type=template&id=54bfc463&scoped=true&"
import script from "./PAKurzpruefung.vue?vue&type=script&lang=js&"
export * from "./PAKurzpruefung.vue?vue&type=script&lang=js&"
import style0 from "./PAKurzpruefung.vue?vue&type=style&index=0&id=54bfc463&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfc463",
  null
  
)

export default component.exports